export default "__VITE_ASSET__757fd0a2__"